<template>
  <div :class="$style.component">
    <a :href="t('creativeCommonsUrl')">{{t('creativeCommonsLabel')}}</a>
    <a :href="t('megatrenditUrl')">{{t('megatrenditLabel')}}</a>
    <a :href="t('megatrendit2023Url')">{{t('megatrendit2023Label')}}</a>
    <a :href="t('ennakointiUrl')">{{t('ennakointiLabel')}}</a>
    <a :href="t('trenditHaltuunUrl')">{{t('trenditHaltuunLabel')}}</a>
    <a :href="t('tulevaisuuskolmioUrl')">{{t('tulevaisuuskolmioLabel')}}</a>
    <a :href="t('ennakoinninElaintarhaUrl')">{{t('ennakoinninElaintarhaLabel')}}</a>
    <a :href="t('tulevaisuudenTyokalupakkiUrl')">{{t('tulevaisuudenTyokalupakkiLabel')}}</a>
    <a :href="t('privacyPolicyUrl')">{{t('privacyPolicyLabel')}}</a>
  </div>
</template>

<script>
import useTranslations from '@/composition/useTranslations'

export default {
  setup () {
    return {
      t: useTranslations(),
    }
  },
}
</script>

<style module lang="scss">
.component {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: variables.$spacing-16;
  padding: 40px 40px 40px 40px;
}
</style>
